import React, { useState, useContext, useEffect, Fragment } from "react";
import StepperNavigationButtons from "../../StepperNavigationButtons/StepperNavigationButtons";
import { EWContext } from "../../../context/EWContext";
import AHRI from "./AHRILookup/AHRILookup";
import FormBuilder from "../FormBuilder/FormBuilder";
import {
   getFormAnswers,
   findElementIntoArray,
   arrayFieldsToObject,
} from "../../../utils/utils";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import Backdrop from "../../../hoc/Backdrop/Backdrop";
import { LANGUAGE_TEXT } from "../../../constants";

function AHRILookupForm(props) {
   const [accountState, setAccountState] = useContext(EWContext);

   const {
      customErrors,
      questions: { ahri: questions },
      answers: { ahri: answers },
      version,
      conditionSpecificBehaviors,
   } = accountState;

   const [loading, setLoading] = useState(false);
   const loadingData = useState(false)[0];
   const [errorFields, setErrorFields] = useState(true);
   const [isValidForm, setIsValidForm] = useState(false);
   const [ahriNumberAnswer, setAhriNumberAnswer] = useState(
      findElementIntoArray(answers, "id", "ahri_number")
   );
   const [ahriNumberHelper, setAhriNumberHelper] = useState({
      value: "",
      textValue: "",
   });
   const [userInfoFormAnswers, setUserInfoFormAnswers] = useState(answers);
   const [productId, setProductId] = useState(1);
   const makeOptions = useState([])[0];
   const errorInForm = useState({
      message: customErrors.genericError,
      genericMessage: customErrors.contactError,
      labelButton: "Back",
      error: false,
   })[0];
   const { group, handleNext, handleBack } = props;
   let questions1 = [];
   const [question2, setquestion2] = useState(questions);
   const [installationZipCode, setInstallationZipCode] = useState("");
   const AHRI_QUESTION = {
      id: "ahri_number",
      name: "ahri_number",
      label:
         accountState?.conditionSpecificBehaviors?.translateText &&
         accountState?.storeInfo?.languageCode
            ? LANGUAGE_TEXT[accountState?.storeInfo?.languageCode]
                 ?.ahri_auto_fill
            : "Enter AHRI Number, to autofill product info below.",
      summaryLabel: "AHRI Number",
      summaryOrder: 1,
      required: false,
      group: "ahri",
      position: 0,
      placeholder: "Type an AHRI Number",
      field: {
         type: "text",
         showOnSummary: true,
         values: [],
         validators: [],
         errorMessages: [],
      },
   };

   useEffect(() => {
      if (answers.length > 0) {
         conditionSpecificBehaviors?.cr_summit_utilities && setServiceZipCode();
         const formIsAnswered = answers.every((field) => {
            if (field.type === "date") {
               if (field.value == "Invalid Date") {
                  return false;
               }
               let dateRange = questions.find((ques) => ques.id === field.id)
                  .field.rangeDates;

               if (dateRange?.minDate?.date) {
                  if (
                     new Date(field.value) < new Date(dateRange.minDate.date)
                  ) {
                     return false;
                  }
               }

               if (dateRange?.maxDate?.date) {
                  if (
                     new Date(field.value) > new Date(dateRange.maxDate.date)
                  ) {
                     return false;
                  }
               }
            }
            return field ? (field.required ? field.value !== "" : true) : false;
         });
         if (formIsAnswered) {
            setErrorFields(false);
         } else {
            setErrorFields(true);
         }
      } else {
         setErrorFields(true);
      }
      // eslint-disable-next-line
   }, [answers]);

   useEffect(() => {
      if (isValidForm) {
         // Saving answers in the App state
         setAccountState((prevAccountState) => ({
            ...prevAccountState,
            ...{
               answers: {
                  ...prevAccountState.answers,
                  ahri: [...userInfoFormAnswers],
               },
               submitAttempts: 0,
               callSavingsService: {
                  ...prevAccountState.callSavingsService,
                  flag: true,
                  answers: "ahri",
               },
               pimcore: { ...prevAccountState.pimcore, productId },
            },
         }));
         setLoading(false);
         handleNext(true);
      }
   }, [
      isValidForm,
      userInfoFormAnswers,
      setAccountState,
      handleNext,
      productId,
   ]);

   useEffect(() => {
      if (errorInForm.error) {
         setAccountState((prevAccountState) => ({
            ...prevAccountState,
            ...{
               submitAttempts: prevAccountState.submitAttempts + 1,
               eligibilityError: errorInForm,
            },
         }));
      }
   }, [errorInForm, setAccountState]);

   const setServiceZipCode = () => {
      accountState.answers.validate.forEach(
         (data) => data.id === "zip" && setInstallationZipCode(data.value)
      );
   };

   const assignValueToZipCode = (userInputAnswers) => {
      if (conditionSpecificBehaviors?.cr_summit_utilities) {
         userInputAnswers[
            conditionSpecificBehaviors?.cr_installationZipCode
         ].value =
            userInputAnswers[
               conditionSpecificBehaviors?.cr_installationZipCode
            ] && installationZipCode;
         userInputAnswers[
            conditionSpecificBehaviors?.cr_installationZipCode
         ].textValue =
            userInputAnswers[
               conditionSpecificBehaviors?.cr_installationZipCode
            ] && installationZipCode;
      }
   };

   const getAHRIAnswer = (ahriAnswers, ahri_number, state) => {
      const newQuestions = [...questions];
      newQuestions.push(AHRI_QUESTION);
      const stateAnswers = arrayFieldsToObject(
         newQuestions,
         "id",
         answers,
         version
      );
      const newAhriAnswers = { ...stateAnswers, ...ahriAnswers, ahri_number };
      let formAnswers = getFormAnswers(
         newAhriAnswers,
         newQuestions,
         version,
         state
      );
      const ahri_number_answer = findElementIntoArray(
         formAnswers,
         "id",
         "ahri_number"
      );
      setAhriNumberAnswer(ahri_number_answer);
      return { formAnswers, ahri_number_answer };
   };

   const AHRILookUpHandler = (ahriResponse) => {
      const { AHRINumber, AHRIInformation } = ahriResponse;
      let productIdTemp = 1;
      let ahriAnswers = {};
      let ahri_number = { value: AHRINumber, textValue: AHRINumber };
      setAhriNumberHelper(ahri_number);
      if (AHRIInformation) {
         const brandName = AHRIInformation?.brand_name || "";
         const indoorModelNumber = AHRIInformation?.indoor_model_number || "";
         const furnaceModelNumber = AHRIInformation?.furnace_model_number || "";
         const outdoorModelNumber =
            AHRIInformation?.outdoor_unit_model_number || "";
         const modelNumber = AHRIInformation?.model_number || "";
         const outdoorUnitBrandName =
            AHRIInformation?.outdoor_unit_brand_name || "";
         const indoorUnitBrandName = AHRIInformation?.indoor_brand_name || "";
         const type = AHRIInformation?.type || "";
         const uef = AHRIInformation?.uef || "";
         productIdTemp = AHRIInformation?.product_id || 1;
         ahriAnswers = {
            brand_name: { value: brandName, textValue: brandName },
            indoor_model_number: {
               value: indoorModelNumber,
               textValue: indoorModelNumber,
            },
            outdoor_model_number: {
               value: outdoorModelNumber,
               textValue: outdoorModelNumber,
            },
            furnace_model_number: {
               value: furnaceModelNumber,
               textValue: furnaceModelNumber,
            },
            model_number: { value: modelNumber, textValue: modelNumber },
            outdoor_brand_name: {
               value: outdoorUnitBrandName,
               textValue: outdoorUnitBrandName,
            },
            indoor_brand_name: {
               value: indoorUnitBrandName,
               textValue: indoorUnitBrandName,
            },
            type: { value: type, textValue: type },
            uef: { value: uef, textValue: uef },
         };
      } else {
         const emptyValue = { value: "", textValue: "" };
         ahriAnswers = {
            brand_name: emptyValue,
            outdoor_model_number: emptyValue,
            indoor_model_number: emptyValue,
            furnace_model_number: emptyValue,
            model_number: emptyValue,
            outdoor_brand_name: emptyValue,
            indoor_brand_name: emptyValue,
            type: emptyValue,
            uef: emptyValue,
         };
      }

      const { formAnswers, ahri_number_answer } = getAHRIAnswer(
         ahriAnswers,
         ahri_number
      );
      let newAnswers = [...formAnswers];
      setUserInfoFormAnswers(formAnswers);
      setProductId(productIdTemp);
      setAccountState((prevAccountState) => ({
         ...prevAccountState,
         answers: {
            ...prevAccountState.answers,
            ahri: [...newAnswers],
         },
         callSavingsService: {
            ...prevAccountState.callSavingsService,
            ahriNumberAnswer: ahri_number_answer,
         },
         pimcore: { ...prevAccountState.pimcore, productIdTemp },
      }));
   };

   const handleOnFormAnswered = (answers) => {
      assignValueToZipCode(answers);
      let newAnswers = { ...answers };
      let { formAnswers } = getAHRIAnswer(
         newAnswers,
         ahriNumberHelper,
         accountState
      );
      let formAnsw = Object.assign(formAnswers);
      let modifiedAnswers = [];

      /**On the based of Install Furnace Value , Auto populating the Checkbox value */
      if (conditionSpecificBehaviors?.cr_exiting_furnace_check) {
         if (
            answers[conditionSpecificBehaviors.cr_furance_question_id].value ===
            conditionSpecificBehaviors.cr_furnace_value
         ) {
            formAnswers = formAnsw.map((el) =>
               el.id === conditionSpecificBehaviors.cr_furnace_id
                  ? { ...el, value: true, textValue: true }
                  : el
            );
            setUserInfoFormAnswers(formAnswers);
         }
      }
      /**On the Based of installation type modifying the questions on ui screen*/
      if (conditionSpecificBehaviors?.cr_installation_check) {
         if (
            answers?.installation_type?.value ===
            conditionSpecificBehaviors?.cr_installation_dropdown_value
         ) {
            questions1 = [];
            questions.forEach((item) => {
               if (item.cr_installation_type === true) {
                  modifiedAnswers.push(item.id);
                  questions1.push(item);
                  setquestion2(questions1);
               }
            });
         } else if (
            answers?.installation_type?.value ===
            conditionSpecificBehaviors?.cr_installation_dropdown_values
         ) {
            setquestion2(questions);
         }
      }

      /**On the based of installtaion modyfying the answers for validation with unique condition*/
      if (conditionSpecificBehaviors?.cr_installation_check) {
         if (
            answers?.installation_type?.value ===
            conditionSpecificBehaviors?.cr_installation_dropdown_value
         ) {
            formAnswers = [];
            formAnsw.forEach((item) => {
               modifiedAnswers.forEach((ite) => {
                  if (item.id === ite) {
                     formAnswers.push(item);
                  }
               });
            });
         }
      }
      const formIsAnswered = formAnswers.every((field) => {
         return field.required ? field.value !== "" : true;
      });
      setUserInfoFormAnswers(formAnswers);
      setAccountState((prevAccountState) => ({
         ...prevAccountState,
         answers: {
            ...prevAccountState.answers,
            ahri: [...formAnswers],
         },
      }));
      if (formIsAnswered) {
         setErrorFields(false);
      } else {
         setErrorFields(true);
      }
   };

   const handleSubmit = (evt) => {
      setLoading(true);
      evt.preventDefault();
      setAccountState((prevAccountState) => ({
         ...prevAccountState,
      }));
      setIsValidForm(true);
   };

   return (
      <Fragment>
         <Backdrop open={loadingData} />
         <FormBuilder
            topComponent={
               <AHRI
                  onAHRILookUp={AHRILookUpHandler}
                  ahriNumberValue={ahriNumberAnswer?.textValue || ""}
               />
            }
            questions={question2}
            answers={answers}
            onFormAnswered={handleOnFormAnswered}
            handleSubmit={handleSubmit}
            formInstructions={group.instructions}
            extraInfoAfterRequired={group.extraInfoAfterRequired}
            customConfig={{
               dropdownOptions: {
                  brand_name: makeOptions,
               },
            }}
         >
            <StepperNavigationButtons
               handleBack={handleBack}
               handleNext={() => null}
               loading={loading}
               nextButtonDisabled={errorFields}
            />
         </FormBuilder>
      </Fragment>
   );
}

export default withErrorHandler(AHRILookupForm);
